import React from 'react';
import { cn } from '../../../lib/utils';

type Variant = 'default' | 'ghost' | 'warm';
type Size = 'sm' | 'md' | 'lg';

export interface TaskyIconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  'aria-label': string;
}

const variantClass: Record<Variant, string> = {
  default: 'bg-primary text-white hover:bg-primary-hover',
  ghost: 'text-gray-600 hover:text-dark hover:bg-warm-hover',
  warm: 'bg-warm-surface text-dark hover:bg-warm-hover',
};

const sizeClass: Record<Size, string> = {
  sm: 'h-8 w-8 [&_svg]:size-4',
  md: 'h-10 w-10 [&_svg]:size-5',
  lg: 'h-12 w-12 [&_svg]:size-6',
};

export const TaskyIconButton = React.forwardRef<HTMLButtonElement, TaskyIconButtonProps>(
  ({ variant = 'default', size = 'md', className, disabled, children, ...rest }, ref) => (
    <button
      ref={ref}
      {...rest}
      disabled={disabled}
      className={cn(
        'inline-flex items-center justify-center rounded-full transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2',
        variantClass[variant],
        sizeClass[size],
        disabled && 'bg-gray-200 text-gray-400 cursor-not-allowed hover:bg-gray-200',
        className,
      )}
    >
      {children}
    </button>
  ),
);
TaskyIconButton.displayName = 'TaskyIconButton';
